export default angular
  .module('app.holding.dashboard.cryptocurrencies')
  .factory('HoldingCryptocurrencies', HoldingCryptocurrencies)
  .name;

function HoldingCryptocurrencies() {
  'ngInject';

  const CURRENCIES = [
    {
      code: 'Bitcoin',
      name: 'Bitcoin',
      symbol: 'BTC',
      decimals: 8,
    },
    {
      code: 'Ether',
      name: 'Ether',
      symbol: 'ETH',
      decimals: 8,
    },
  ];

  return {
    getCurrencyByCode,
  };

  function getCurrencyByCode(code) {
    return CURRENCIES.find(currency => currency.code === code) || CURRENCIES[0];
  }
}



// WEBPACK FOOTER //
// ./src/holding/modules/app/modules/holding/modules/dashboard/modules/cryptocurrencies/services/cryptocurrencies.js